import { MONTHS } from '../../reports/utils/shell';

// Builds the OPU session report body HTML (wrapped by reportShell). Model copied
// from v1 (features/opu/utils/pdf.js): meta cards + aspirations table with
// per-row viability badge + totals. Rendered to PDF by POST /admin/reports/pdf.

function longDate(ymd) {
    if (!ymd) return '—';
    const [y, m, d] = String(ymd).slice(0, 10).split('-');
    if (!y || !m || !d) return ymd;
    return `${Number(d)} de ${MONTHS[Number(m) - 1] || ''} de ${y}`;
}

function viabColor(rate) {
    if (rate >= 70) return '#15803d';
    if (rate >= 40) return '#b45309';
    return '#dc2626';
}
function viabBg(rate) {
    if (rate >= 70) return '#dcfce7';
    if (rate >= 40) return '#fef3c7';
    return '#fee2e2';
}

function esc(v) {
    return String(v ?? '').replace(/[&<>"]/g, (c) => (
        { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]
    ));
}

function aspiradorName(session) {
    const lead = (session.staff || []).find(s => s.role === 'lead_vet' && s.status !== 0);
    return lead?.user?.name || '—';
}

function teamNames(session) {
    const active = (session.staff || []).filter(s => s.status !== 0);
    return active.length ? active.map(s => esc(s.user?.name)).join(', ') : '—';
}

export function opuReportFilename(session) {
    return (session?.code || 'opu').toLowerCase();
}

export function buildOpuReportBody(session = {}) {
    const aspirations = (session.aspirations || []).filter(a => a.status !== 0);

    const totals = aspirations.reduce((acc, a) => {
        acc.total += Number(a.total) || 0;
        acc.viables += Number(a.viables) || 0;
        return acc;
    }, { total: 0, viables: 0 });
    const totalRate = totals.total ? Math.round((totals.viables / totals.total) * 100) : 0;

    const rows = aspirations.map((a, i) => {
        const total = Number(a.total) || 0;
        const viables = Number(a.viables) || 0;
        const rate = total ? Math.round((viables / total) * 100) : 0;
        const remarks = typeof a.remarks === 'string' ? a.remarks : '';
        return `<tr>
            <td>${i + 1}</td>
            <td>${esc(a.donor?.name) || '—'}</td>
            <td>${esc(a.donor?.number) || '—'}</td>
            <td>${total}</td>
            <td>${viables}</td>
            <td><span class="badge" style="background:${viabBg(rate)};color:${viabColor(rate)};">${rate}%</span></td>
            <td>${esc(remarks) || '—'}</td>
        </tr>`;
    }).join('');

    return `
        <h1 class="report-title">Informe de aspiración folicular (OPU)</h1>
        <p class="report-subtitle">${esc(session.code)} · ${longDate(session.date)}</p>

        <div class="meta">
            <div class="meta-item"><strong>Sesión</strong><span>${esc(session.code)}</span></div>
            <div class="meta-item"><strong>Fecha</strong><span>${longDate(session.date)}</span></div>
            <div class="meta-item"><strong>Finca</strong><span>${esc(session.farm?.name) || '—'}</span></div>
            <div class="meta-item"><strong>Aspirador</strong><span>${esc(aspiradorName(session))}</span></div>
            <div class="meta-item"><strong>Equipo</strong><span>${teamNames(session)}</span></div>
            <div class="meta-item"><strong>Donantes</strong><span>${aspirations.length}</span></div>
        </div>

        <table>
            <thead>
                <tr>
                    <th>#</th><th>Donante</th><th>Número</th>
                    <th>Óvocitos</th><th>Viables</th><th>% Viab.</th><th>Observaciones</th>
                </tr>
            </thead>
            <tbody>${rows}</tbody>
            <tfoot>
                <tr>
                    <td colspan="3">Totales</td>
                    <td>${totals.total}</td>
                    <td>${totals.viables}</td>
                    <td><span class="badge" style="background:${viabBg(totalRate)};color:${viabColor(totalRate)};">${totalRate}%</span></td>
                    <td>—</td>
                </tr>
            </tfoot>
        </table>
    `;
}
